import React from "react";
import "./LeftAlertDrawer.css";

const LeftAlertDrawer = ({
  show,
  message,
  remainingSeconds = 0,
  totalSeconds = 120,
}) => {
  let drawerClasses = "left-alert";
  if (show) {
    drawerClasses = "left-alert open";
  }

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeDisplay = `${minutes}:${seconds.toString().padStart(2, "0")}`;
  const progressPercent = totalSeconds > 0 ? (remainingSeconds / totalSeconds) * 100 : 0;

  // Color transitions: green > 60%, yellow 30-60%, red < 30%
  let barColor = "#28a745"; // green
  if (progressPercent <= 30) barColor = "#dc3545"; // red
  else if (progressPercent <= 60) barColor = "#ffc107"; // yellow

  return (
    <nav className={drawerClasses}>
      <ul>
        <li>{message}</li>
        {remainingSeconds > 0 && (
          <li>
            <div className="session-progress-container">
              <div
                className="session-progress-bar"
                style={{ width: `${progressPercent}%`, backgroundColor: barColor }}
              />
            </div>
            <div className="session-countdown">{timeDisplay} remaining</div>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default LeftAlertDrawer;
